import { UPDATEFIELDSTATUS_SUCCESS, UPDATEFIELDSTATUS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const updateFieldStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEFIELDSTATUS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEFIELDSTATUS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateFieldStatusReducer;
